import {Component, HostBinding} from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';

declare var Waves: any;
@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  @HostBinding('class') public cssClass = '';

  title = 'ITS Web Portal';

  constructor(private router: Router) {
    router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        Waves.init();
      }
    });
  }

}
